import React from 'react';
import TextRender from '../TextRender/TextRender';

interface IHtmlRenderProps {
  text: string;
}

const HtmlRender = ({ text }: IHtmlRenderProps): JSX.Element => {
  if (text && typeof text === 'string') {
    const hasHtmlElements = text.match(
      /<p.*?>.*?<\/p>|<ul.*?>.*?<\/ul>|<li.*?>.*?<\/li>|<ol.*?>.*?<\/ol>/g
    );

    if (hasHtmlElements) {
      var processedText = text;
      hasHtmlElements.forEach(
        (element) =>
          (processedText = processedText.replace(
            element,
            '|br|' + element + '|br|'
          ))
      );
      const processedElements = processedText
        .split('|br|')
        .filter((element) => element !== '');
      return (
        <>
          {processedElements.map((value: string) => {
            const innerStart = value.indexOf('>') + 1;
            switch (value.substring(1, 3)) {
              case 'p>':
                return (
                  <p key={`htmlrender-p-${value}`}>
                    <HtmlRender
                      text={value.substring(innerStart, value.length - 4)}
                    />
                  </p>
                );
              case 'ol':
                return (
                  <ol key={`htmlrender-ol-${value}`}>
                    <HtmlRender
                      text={value.substring(innerStart, value.length - 5)}
                    />
                  </ol>
                );
              case 'ul':
                return (
                  <ul key={`htmlrender-ul-${value}`}>
                    <HtmlRender
                      text={value.substring(innerStart, value.length - 5)}
                    />
                  </ul>
                );
              case 'li':
                return (
                  <li key={`htmlrender-li-${value}`}>
                    <HtmlRender
                      text={value.substring(innerStart, value.length - 5)}
                    />
                  </li>
                );
              default:
                return (
                  <TextRender
                    key={`htmlrender-text-${value}`}
                    text={value}
                    validateText
                  />
                );
            }
          })}
        </>
      );
    } else {
      return <TextRender text={text} validateText />;
    }
  }
  return <></>;
};
export default HtmlRender;
